const learnerStory = [
  {
    time: "11 HOURS AGO",
    msg:
      "Google makes it easier to run high-performance workloads on its cloud platform",
    avatar: "/static/images/avatar/1.jpg",
    name: "Anna Møller",
    job: "Author at Panoply Store",
  },
  {
    time: "21 HOURS AGO",
    msg:
      "Musicians, actors and influencers plan social media takeover to support #MarchForOurLives",
    avatar: "/static/images/avatar/1.jpg",
    name: "Bertram Jensen",
    job: "Author at Panoply Store",
  },
  {
    time: "11 HOURS AGO",
    msg:
      "Equity Podcast: Facebook says ‘oops’ and Dropbox with a wave of enterprise IPOs",
    avatar: "/static/images/avatar/1.jpg",
    name: "Aksel Johansen",
    job: "Author at Panoply Store",
  },
];

export default learnerStory;
